export const getDialogVisibility = (state = {visibility: true}, action) => {
    switch(action.type) {
        case "change2":
            return {
                visibility: action.payload
            }
        default:
            return state;
    }
}